import { render, staticRenderFns } from "./DiagnosticTestReport.vue?vue&type=template&id=91527054&"
import script from "./DiagnosticTestReport.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticTestReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports